module.exports = __webpack_public_path__ + "img/w3_logout_grey.ba54a40d.png";